import React from 'react'
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UseAdminAddCoupon from '../../CustomHooks/Admin/UseAdminAddCoupon';


const AdminAddCouponComp = () => {
    const [isFormValid, DateRef, valiadteCouponDate, ValidateCouponName, ValidateCouponValue, isPress, loading, couponName, ChangeCouponName, couponDate, ChangeCouponDate, couponDiscountValue, ChangeCouponValue, SubmitCoupon] = UseAdminAddCoupon()
    return (
        <Container fluid>
            <Row className="justify-content-start py-5">
                <h3 className="pb-4 fw-bold"> Add New Coupon</h3>
                <Col sm="8">
                    <input
                        type="text"
                        className="form-control d-block mt-3 px-3 h-60"
                        placeholder="Type Coupon Name"
                        value={couponName}
                        onChange={ChangeCouponName}
                        onBlur={ValidateCouponName}
                    />
                    <input
                        type="text"
                        className="form-control  d-block mt-3 px-3 h-60"
                        value={couponDate}
                        onChange={ChangeCouponDate}
                        ref={DateRef}
                        onFocus={() => DateRef.current.type = "date"}
                        onBlur={valiadteCouponDate}
                        placeholder="Expire Date"

                    />
                    <input
                        type="number"
                        className="form-control  d-block mt-3 px-3 h-60"
                        placeholder="Discount Value"
                        value={couponDiscountValue}
                        onChange={ChangeCouponValue}
                        onBlur={ValidateCouponValue}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm="8" className="d-flex justify-content-end ">
                    <button className="action-button d-inline mt-2  btn text-white dark-bg mb-5" onClick={SubmitCoupon} disabled={!isFormValid}>
                        {isPress ? loading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
                    </button>
                </Col>
            </Row>
            <ToastContainer limit={4} />
        </Container >
    )
}

export default AdminAddCouponComp

